import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { readContract } from '@wagmi/core';
const abi = require('src/contracts/abi-dev/pdogBsc.json');

@Injectable({
  providedIn: 'root'
})
export class BscContractService {

  constructor(private commonService: CommonService) { }

  async getDecimals() {
    const decimals:any = await readContract({
      address: environment.BSC_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'decimals',
      args:[]
    })

    return decimals;
  }

  async getBalance(address) {
    const balance:any = await readContract({
      address: environment.BSC_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'balanceOf',
      args:[address]
    })

    return balance;
  }

  async getPairAddress() {
    const pairAddress:any = await readContract({
      address: environment.BSC_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'pancakeswapV2Pair',
      args:[]
    })

    return pairAddress;
  }

  async getAllowance(ownerAddr, spenderAddr) {
    const allowance:any = await readContract({
      address: environment.BSC_CONTRACT_ADDRESS as any,
      abi: abi,
      functionName: 'allowance',
      args:[ownerAddr,spenderAddr]
    })

    return allowance;
  }
}
